import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { JournalCommonRoutingModule } from './journal-common-routing.module';
import { JournalCommonComponent } from './journal-common/journal-common.component';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MaterialModule } from '@sparro/app/material.module';

import { CardsModule } from '@sparro/app/shared/components/cards/cards.module';
import { LoaderModule } from '@sparro/app/shared/components/loader/loader.module';
import { LayoutModule } from '@sparro/app/shared/components/layout/layout.module';
import { ButtonsModule } from '@sparro/app/shared/components/buttons/buttons.module';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { FieldsModule } from '@sparro/app/shared/components/forms/fields/fields.module';



@NgModule({
  declarations: [JournalCommonComponent],
  imports: [
    CommonModule,
    JournalCommonRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    MaterialModule,
    LoaderModule,
    CardsModule,
    LayoutModule,
    ButtonsModule,
    NgxMatSelectSearchModule,
    FieldsModule
  ]
})
export class JournalCommonModule { }
